module.exports = __webpack_public_path__ + "static/media/textediter_title_en.e27ec9fc.svg";